export const MODES = {
  VIEW: 'view',
  EDIT: 'edit',
  ADD: 'add',
};

const lockedRowsFromSpecs = (specs) =>
  (Array.isArray(specs) ? specs : [])
    .filter((spec) => spec?.partNumber)
    .map((spec) => ({ partNumber: spec.partNumber, locked: true }));

export const initialEditorState = (specs) => ({
  mode: MODES.VIEW,
  rows: lockedRowsFromSpecs(specs),
});

export const heaterEditorReducer = (state, action) => {
  switch (action.type) {
    case 'enterEdit':
      return {
        mode: MODES.EDIT,
        rows: lockedRowsFromSpecs(action.specs).map((row) => ({
          ...row,
          locked: false,
        })),
      };

    case 'enterAdd':
      return {
        mode: MODES.ADD,
        rows: [
          ...lockedRowsFromSpecs(action.specs),
          { partNumber: '', locked: false },
        ],
      };

    case 'setPartNumber': {
      if (state.mode === MODES.VIEW) {
        return state;
      }
      const target = state.rows[action.index];
      if (!target || target.locked) {
        return state;
      }
      if (typeof action.partNumber !== 'string') {
        return state;
      }
      return {
        ...state,
        rows: state.rows.map((row, index) =>
          index === action.index
            ? { ...row, partNumber: action.partNumber.toUpperCase() }
            : row,
        ),
      };
    }

    case 'removeRow': {
      if (state.mode === MODES.VIEW) {
        return state;
      }
      const target = state.rows[action.index];
      if (!target || target.locked) {
        return state;
      }
      return {
        ...state,
        rows: state.rows.filter((_, index) => index !== action.index),
      };
    }

    case 'cancel':
      return initialEditorState(action.specs);

    case 'syncFromSpecs':
      return state.mode === MODES.VIEW
        ? initialEditorState(action.specs)
        : state;

    default:
      return state;
  }
};
